import {
  VabsCreateBsbPaymentInput,
  VabsCreateIfscPaymentInput,
  VabsCreateSwiftPaymentInput,
  VabsUpdatePaymentFavoriteInput,
  requestsClient,
} from '@/shared/api';

// export const createAccountMutation = async ({
//   currencyId,
//   accountId,
// }: ICreateAccountMutationParams) => {
//   const { vabsAccCreateMyAccountBalances } =
//     await requestsClient.vabsAccCreateMyAccountBalances({
//       input: {
//         currencyIds: [currencyId],
//         virtualAccountId: accountId,
//       },
//     });
//   return vabsAccCreateMyAccountBalances;
// };

export const createIfscMutation = async (input: VabsCreateIfscPaymentInput) => {
  const { vabsCreateMyIfscPayment } =
    await requestsClient.vabsCreateMyIfscPayment({
      input,
    });
  return vabsCreateMyIfscPayment;
};

export const createSwiftMutation = async (
  input: VabsCreateSwiftPaymentInput,
) => {
  const { vabsCreateMySwiftPayment } =
    await requestsClient.vabsCreateMySwiftPayment({
      input,
    });
  return vabsCreateMySwiftPayment;
};

export const createBsbMutation = async (input: VabsCreateBsbPaymentInput) => {
  const { vabsCreateMyBsbPayment } =
    await requestsClient.vabsCreateMyBsbPayment({
      input,
    });
  return vabsCreateMyBsbPayment;
};

export const addToFavMutation = async (
  input: VabsUpdatePaymentFavoriteInput,
) => {
  const { vabsUpdateMyPaymentFavorite } =
    await requestsClient.vabsUpdateMyPaymentFavorite({
      input,
    });
  return vabsUpdateMyPaymentFavorite;
};
